import React, { useState, useEffect } from 'react';
import { fieldClass } from './ui';

/**
 * Sélecteur de deck stable :
 * - <select> natif pour choisir parmi les decks existants (fiable sur mobile)
 * - Option "Autre deck..." qui révèle un <input> propre pour saisir un nom libre
 */
const CUSTOM_VALUE = '__custom__';

const DeckSelector = ({ value, onChange, decks, label = 'Deck', required = false, className = '' }) => {
  const isKnown = decks.includes(value);
  const [isCustom, setIsCustom] = useState(!isKnown && value !== '');
  const [customInput, setCustomInput] = useState(!isKnown && value !== '' ? value : '');

  // Sync si value change de l'extérieur (ex: reset)
  useEffect(() => {
    if (value === '') {
      setIsCustom(false);
      setCustomInput('');
    } else if (decks.includes(value)) {
      setIsCustom(false);
    }
  }, [value, decks]);

  const handleSelectChange = (e) => {
    if (e.target.value === CUSTOM_VALUE) {
      setIsCustom(true);
      setCustomInput('');
      onChange('');
    } else {
      setIsCustom(false);
      setCustomInput('');
      onChange(e.target.value);
    }
  };

  const handleCustomChange = (e) => {
    setCustomInput(e.target.value);
    onChange(e.target.value);
  };

  const handleCancelCustom = () => {
    setIsCustom(false);
    setCustomInput('');
    const fallback = decks[0] || '';
    onChange(fallback);
  };

  return (
    <div>
      {label && <label className="label-caps block mb-2">{label}</label>}

      {!isCustom ? (
        <select
          value={decks.includes(value) ? value : (decks[0] || '')}
          onChange={handleSelectChange}
          required={required}
          className={`${fieldClass} ${className}`}
        >
          {decks.map((deck, i) => (
            <option key={i} value={deck}>{deck}</option>
          ))}
          <option value={CUSTOM_VALUE}>Saisir un autre deck…</option>
        </select>
      ) : (
        <>
          <div className="flex gap-2">
            <input
              type="text"
              value={customInput}
              onChange={handleCustomChange}
              placeholder="Nom exact du deck dans Notion"
              required={required}
              autoFocus
              className={`flex-1 ${fieldClass} border-clay-500 ${className}`}
            />
            <button
              type="button"
              onClick={handleCancelCustom}
              className="px-3 text-ink-400 hover:text-ink-900 transition-colors"
              title="Annuler"
              aria-label="Annuler la saisie libre"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.75} viewBox="0 0 24 24">
                <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>
          <p className="text-xs text-ink-400 mt-1.5">
            Le nom doit correspondre exactement à celui du deck dans Notion.
          </p>
        </>
      )}
    </div>
  );
};

export default DeckSelector;
